export const CSRF_HEADER_NAME = 'X-Zapier-CSRF';
export const LOCAL_SESSION_JWT_COOKIE_NAME = 'session.jwt';
export const SESSION_JWT_COOKIE_NAME = '__Host-session.jwt';

// Path (relative to /api/bridge) that ATC answers at the edge before proxying;
// handleBridgeRequest replicates it for local development.
export const SESSION_COOKIE_STATUS_PATH = '/api/bridge/session-cookie-status';

export const SERVICE_MAP = {
  functions: 'https://functionsapi.zapier-staging.com/api',
  tables: 'https://tablesapi.zapier-staging.com/api',
  identity: 'https://zapier-staging.com/api',
  billing: 'https://zapier-staging.com/api',
  edge: 'https://zapier-staging.com/api',
  'zap-execution': 'https://zapier-staging.com/api',
  organization: 'https://zapier-staging.com/api',
  editor: 'https://zapier-staging.com/api',
  pigeon: 'https://zapier-staging.com/api',
  'byom-api': 'https://byom-api.zapier-staging.com/api',
  'notification-rules': 'https://notification-rules.zapier-staging.com/api',
  catalog: 'https://zapier-staging.com/api/catalog',
  searchaggregator: 'https://zapier-staging.com/api/bridge/searchaggregator',
  agents: 'https://agents.zapier-staging.com/api',
  'anomaly-service': 'https://zapier-staging.com/api',
  recommendations: 'https://zapier-staging.com/api',
  subscriptions: 'https://zapier-staging.com/api',
  guardrailsapi: 'https://guardrailsapi.zapier-staging.com/api',
  approvals: 'https://approvalsapi.zapier-staging.com/api',
};

export const UNSAFE_METHODS = ['POST', 'PUT', 'DELETE', 'PATCH'];
